import "core-js/modules/es6.string.fixed";
import "core-js/modules/es6.string.fixed";

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n  display: inline-block;\n  margin: 0 auto;\n  line-height: 0;\n  &[data-plain-bg='true'] {\n    background-color: home-hero-img-bg;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n  font-size: 28;\n  font-weight: 600;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  padding-top: 30;\n  text-align: center;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

import staticQueryData from "../../../../public/static/d/53695131.json";
import React from 'react';
import { StaticQuery } from 'gatsby';
import Img from 'gatsby-image';
import styled, { useColorMode } from '@xstyled/styled-components';
var QUERY = "53695131";
var Container = styled.div(_templateObject());
var Title = styled.h1(_templateObject2());
var ImgContainer = styled.div(_templateObject3());

function getLogo(data, mode) {
  if (mode === 'dark' && data.logoDark) return data.logoDark;
  return data.logo || null;
}

export function HomeHero(_ref) {
  var title = _ref.title,
      plainBg = _ref.plainBg;

  var _useColorMode = useColorMode(),
      mode = _useColorMode[0];

  return React.createElement(StaticQuery, {
    query: QUERY,
    render: function render(data) {
      var logo = getLogo(data, mode);
      if (!logo) return null;
      return React.createElement(Container, null, React.createElement(ImgContainer, {
        "data-plain-bg": plainBg
      }, React.createElement(Img, {
        fixed: logo.childImageSharp.fixed,
        alt: data.site.siteMetadata.title
      })), React.createElement(Title, null, title));
    },
    data: staticQueryData
  });
}